import Axios from "axios";
import React, { useEffect, useRef, useState } from "react";

/* Redux libs */

/** Styles Components */
import { CardCustom, Title } from "./styles";

/** Components */
import { Col, Dropdown, Icon, Menu, Modal, Row, Table } from "antd";
import DrawerCattleProducer from "../../components/drawers/cattleProducer";
import ButtonStandard from "../../components/utils/button";
import MenuIcon from "../../components/utils/table/icons/menu";
import { Container as MenuContainer } from "../../components/utils/table/menu/styles";
import TagStatus from "../../components/utils/tagStatus";
import {
  cnpjMask,
  cpfMask,
  getOnlyNumber,
} from "../../services/helpersMethodsService";
import { getColumnSearchProps } from "../../utils/tableUtils";
import { useDispatch, useSelector } from "react-redux";
import { Creators as CattleProducerActions } from "../../store/ducks/cattleProducer";

const CattleProducer = () => {
  const signalRef = useRef(Axios.CancelToken.source());
  const searchInputRef = useRef(null);

  const {
    app: { translation, groupSelected, farmSelected },
    cattleProducer: {
      data,
      isLoading,
      pagination: { page, size, tableFilters },
    },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      signalRef.current.cancel("Cancelando apis");
    };
  }, []);

  useEffect(() => {
    if (
      Object.entries(groupSelected).length > 0 &&
      Object.entries(farmSelected).length > 0
    ) {
      fetchData(groupSelected, farmSelected);
    }
  }, [groupSelected?.id, farmSelected?.id]);

  const fetchData = (
    groupSelected,
    farmSelected,
    page = 0,
    sorter = null,
    filters = null,
    size = 10
  ) => {
    const { id: groupId } = groupSelected;
    const { id: farmId } = farmSelected;

    let search = "";

    if (filters && Object.entries(filters).length > 0) {
      Object.entries(filters).forEach(([k, v]) => {
        if (v && v.length > 0) {
          const fieldS = k ? k : null;

          if ("name" === fieldS) {
            search =
              search === ""
                ? `upper(${fieldS}) like upper('%${v}%')`
                : `${search};upper(${fieldS}) like upper('%${v}%')`;
          } else if ("document" === fieldS) {
            const documentOnlyNumbers = getOnlyNumber(String(v));
            search =
              search === ""
                ? `upper(${fieldS}) like upper('%${documentOnlyNumbers}%')`
                : `${search};upper(${fieldS}) like upper('%${documentOnlyNumbers}%')`;
          } else if ("status" === fieldS) {
            search =
              search === "" ? `status = '${v}'` : `${search};status = '${v}'`;
          } else {
            search =
              search === ""
                ? `${fieldS} = '${v}'`
                : `${search};${fieldS} = '${v}'`;
          }
        }
      });
    }

    const sort =
      sorter != null && sorter?.field != null
        ? {
            ...sorter,
            field: sorter.field,
          }
        : null;

    dispatch(
      CattleProducerActions.indexCattleProducers(
        groupId,
        farmId,
        page,
        sort,
        search,
        size
      )
    );
  };

  const handleEdit = async (id) => {
    dispatch(CattleProducerActions.showDrawer("edit", id));
  };

  const handleDelete = async (id) => {
    const { id: groupId } = groupSelected;
    const { id: farmId } = farmSelected;

    Modal.confirm({
      title: translation.cattleProducer.modal.deleteTitle,
      content: translation.cattleProducer.modal.deleteContent,
      okText: translation.buttons.confirm,
      cancelText: translation.buttons.cancel,
      onOk: () => {
        dispatch(
          CattleProducerActions.deleteCattleProducer(groupId, farmId, id)
        );
      },
    });
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    let search = null;
    if (filters && Object.entries(filters).length > 0) {
      search = filters;
    }

    fetchData(
      groupSelected,
      farmSelected,
      pagination.current - 1,
      sorter,
      search,
      pagination.pageSize
    );
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
  };

  const menu = (id, record) => {
    return (
      <Menu>
        <Menu.Item key="1" onClick={() => handleEdit(id)}>
          {translation.table.menu.edit}
        </Menu.Item>
        <Menu.Item key="2" onClick={() => handleDelete(record.id)}>
          {translation.table.menu.delete}
        </Menu.Item>
      </Menu>
    );
  };
  const { Column } = Table;

  const formatDocument = (document) => {
    if (!document) return "";
    const documentOnlyNumbers = getOnlyNumber(document);
    return documentOnlyNumbers.length <= 11
      ? cpfMask(documentOnlyNumbers)
      : cnpjMask(documentOnlyNumbers);
  };

  return (
    <CardCustom>
      <Row type="flex" justify="space-between" className="rowHeader">
        <Col>
          <Title>{translation.cattleProducer.table.title}</Title>
        </Col>
        <Col>
          <ButtonStandard
            buttonType="typeWithoutBackground"
            onClick={() => fetchData(groupSelected, farmSelected)}
          >
            <Icon type="reload" />
          </ButtonStandard>
          <ButtonStandard
            buttonType="addNew"
            onClick={() => dispatch(CattleProducerActions.showDrawer("new"))}
          >
            {translation.cattleProducer.buttons.buttonNew}
          </ButtonStandard>
        </Col>
      </Row>
      <Row type="flex">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Table
            loading={isLoading}
            rowKey="id"
            dataSource={data != null && data.content ? data.content : []}
            pagination={{
              total: data != null ? data.totalElements : 0,
              size: data != null ? size : 10,
              current: data != null ? page + 1 : 1,
              hideOnSinglePage:
                data !== null && Object.entries(data).length !== 0
                  ? data.totalElements > 10
                    ? false
                    : true
                  : true,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "100", "500", "1000", "2000"],
            }}
            size="small"
            scroll={{
              x: true,
            }}
            onChange={handleTableChange}
          >
            <Column
              title={translation.cattleProducer.table.columns.status}
              dataIndex="status"
              key="status"
              align="left"
              sorter
              filtered
              filters={[
                {
                  text: translation.status.active,
                  value: "A",
                },
                {
                  text: translation.status.inactive,
                  value: "I",
                },
              ]}
              filterMultiple={false}
              render={(status) =>
                status === "Active" || status === "A" ? (
                  <TagStatus
                    background="#E2FFE5"
                    borderColor="#33C162"
                    color="#33C162"
                  >
                    {translation.status.active}
                  </TagStatus>
                ) : (
                  <TagStatus
                    background="#FBC7C7"
                    borderColor="#D44C4C"
                    color="#D44C4C"
                  >
                    {translation.status.inactive}
                  </TagStatus>
                )
              }
            />
            <Column
              title={translation.cattleProducer.table.columns.name}
              dataIndex="name"
              sorter
              key="name"
              filteredValue={tableFilters?.name || null}
              align="left"
              {...getColumnSearchProps("name", handleReset, handleSearch)}
            />
            <Column
              title={translation.cattleProducer.table.columns.document}
              dataIndex="document"
              key="document"
              align="left"
              {...getColumnSearchProps("document", handleReset, handleSearch)}
              render={(text) => formatDocument(text)}
            />
            <Column
              align="left"
              render={(text, record) => (
                <Dropdown
                  overlay={menu(record.id, record)}
                  trigger={["click"]}
                  key={record.id}
                >
                  <MenuContainer>
                    <MenuIcon />
                  </MenuContainer>
                </Dropdown>
              )}
            />
          </Table>
        </Col>
      </Row>
      <DrawerCattleProducer />
    </CardCustom>
  );
};

export default CattleProducer;
